import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import {CommonService} from '../../_services/common.services';
import { CellClickedEvent, CheckboxSelectionCallbackParams, ColDef, ColumnApi, HeaderCheckboxSelectionCallbackParams, Module, ModuleRegistry, RowNode } from 'ag-grid-community';
import { Observable, Subject, interval } from 'rxjs';
import 'ag-grid-enterprise';
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import {CompanySharedService} from '../../_services/company-shared.service';
import { BaseRequestService } from 'src/app/_services/base.service';
import { MyToastrService } from 'src/app/_services/toastr.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { GridDataService } from 'src/app/_services/grid-data.service';
import { takeUntil } from 'rxjs/operators';
import { LoaderService } from 'src/app/_services/loader.service';

@Component({
  selector: 'app-ag-grid-table',
  templateUrl: './ag-grid-table.component.html',
  styleUrls: ['./ag-grid-table.component.scss']
})
export class AgGridTableComponent implements OnInit {
  @Output() selectionChange = new EventEmitter();
  @Output() filterChange = new EventEmitter();
  @Output() refreshCallback = new EventEmitter();  
  public selectedRow: any = [];
  private gridApi: any;
  public columnTypes: any;
  public defaultColDef: any;
  public columnDefs: ColDef[] = [];
  public statusBar: any;
  public api: any;
  public columnApi: any;
  // public gridOptions: any;
  sideBar: any;
  autoGroupColumnDef: any;
  public rowGroupPanelShow: any;
  public gridColumnApi: any;
  @Input() columnData = [];
  @Input() rowsData = [];
  @Input() getSummaryData: any = [];
  @Input() selectedRecords: any = [];
  @Input() getUTRNumbers: any = [];
  @Input() agGridOption: any;
  @Input() parameters: any;
  @Output() filteredRecords: any = [];
  rowData: any = [];
  sourceColumnName: any = '';
  searchRec: any = '';
  currentRecon: any;
  remarksData: any = [];
  checked: boolean = false;
  currentReconProcess: any;
  reportBuilder: any;
  allColumns: any;
  rowGroup: any;
  gridOptions: any;
  filteredRowCount: number = 0;
  filteredRowdata: Array<any> = [];
  gridTableSetting: any = [];
  gridTable: any = [];
  currentUser: any;
  glview: boolean = false;
  glcountview: boolean = false;
  reconview: boolean = true;
  showAll: boolean = true;
  notshowAll: boolean = false;
  glreconId: any;
  public getRowStyle: any;
  isLocked: boolean = false;
  rowSelection: "single" | "multiple" = "multiple";
  @Output() changeSourceCallBack = new EventEmitter();
  @Output() changeutrCallBack = new EventEmitter();
  constructor(private authService: AuthenticationService, private http: HttpClient, public cs: CompanySharedService, public commonService: CommonService,
    private chageDetect: ChangeDetectorRef, private baseService: BaseRequestService, private toast: MyToastrService,
    private gridDataService: GridDataService, private loaderService: LoaderService) {
      this.currentReconProcess = this.commonService.currentReconProcess;
      this.sourceColumnName = this.commonService.sourceColumnName;
      this.reportBuilder = this.commonService.customReport ? this.commonService.customReport : false;
      this.currentUser = this.authService.currentUser;
      this.glreconId = this.commonService.glreconid;
      let glname: any = this.commonService.glreconName;
      if (typeof glname === 'object' || glname === undefined || glname === '') { // || typeof glcountrecords === 'object' || glcountrecords === undefined || glcountrecords === ''
        this.reconview = true;
        this.glview = false;
      } else {
        this.reconview = false;
        this.glview = true;
      }
    // console.log("sourceColumn",);
    // || ele.field === 'Recon Remarks' filter: 'agSetColumnFilter'
    setTimeout(() => {
      if(this.sourceColumnName === "authwaiting" || this.sourceColumnName === "rollbackwaiting") {
        this.columnData.forEach((obj: any) => {
          if(obj.field === 'LINK_ID') {
            Object.assign(obj, {rowGroup: true, enableRowGroup: true, enableValue: true, enablePivot: true});
          } 
          else if(obj.field !== 'LINK_ID') {
            Object.assign(obj, {});
            // enableRowGroup: true, enableValue: true, enablePivot: true
          }
        })
      }
      this.columnData.forEach((ele: any) => {
        if(ele.field === 'STATEMENT_DATE') {
          Object.assign(ele, {filter: 'agDateColumnFilter', type: ['dateColumn']})
        } else {
          Object.assign(ele, {filter: 'agSetColumnFilter'})
        }
      })
    });
    this.gridOptions = {
      // PROPERTIES
      // Objects like myRowData and myColDefs would be created in your application
      pagination: true,
      rowModelType: 'clientSide',
      cacheBlockSize: 20, // you can have your custom page size
      onGridReady: (event: any) => {
        console.log(event,'The grid is now ready')
        this.gridApi = event.api;
      },
      // EVENTS
      // Add event handlers
      // CALLBACKS
    }
    this.rowGroupPanelShow = 'always';
    this.autoGroupColumnDef = { 
      minWidth: 50,
      // headerCheckboxSelection: true,
      // headerCheckboxSelectionCurrentPageOnly: true,
    };
    this.sideBar = 'columns';
    this.defaultColDef = {
      minWidth: 50,
      editable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: false,
      resizable: true,
      sortable: true,
      enableRowGroup: true,
    };
    console.log("this.columndata", this.columnData);

    this.columnTypes = {
      numberColumn: {
        width: 50,
        filter: 'agNumberColumnFilter',
      },
      nonEditableColumn: { editable: false },
    };
    this.statusBar = {
      statusPanels: [
        {
          statusPanel: 'agTotalAndFilteredRowCountComponent',
          align: 'left',
        }
      ],
    };
    this.getRowStyle = function(params: any) {
      console.log("asfasfasdf", params.node.rowPinned);
      if (params.node.rowPinned === 'bottom') {
        let c: any = { "background-color": "#e3fbfd", "color": "rgb(34 33 165)", "font-weight": 600 };
        return c;
      }
    };
  }

  // isFirstColumn(
  //   params:
  //     | CheckboxSelectionCallbackParams
  //     | HeaderCheckboxSelectionCallbackParams,
  // ) {
  //   let displayedColumns: any = this.gridApi.getAllDisplayedColumns();
  //   let thisIsFirstColumn: any = displayedColumns[0] === params.column;
  //   return thisIsFirstColumn;
  // }
  generatePinnedBottomData() {
    // generate a row-data with null values
    let result: any = {};
      this.gridColumnApi.getAllGridColumns().forEach((item: any) => {
        result[item.colId] = null;
      });
      return this.calculatePinnedBottomData(result);
  }
  calculatePinnedBottomData(target: any){
    //console.log(target);
    //list of columns fo aggregation
    let columnsWithAggregation = ['DC_AMOUNT']
    if(this.selectedRow.length === 0) {
      columnsWithAggregation.forEach(element => {
        console.log('element', element);
        this.gridApi.forEachNodeAfterFilter((rowNode: RowNode) => {
          if (rowNode.data[element])
            target[element] += Number(rowNode.data[element].toFixed(2));
        });
        if (target[element])
          target[element] = `Total: ${target[element].toFixed(2)}`
      });
    } else if(this.selectedRow.length > 0) {
      columnsWithAggregation.forEach(element => {
        console.log('element', element);
        this.gridApi.getSelectedNodes().forEach((rowNode: any) => {
          if (rowNode.data[element])
            target[element] += Number(rowNode.data[element].toFixed(2));
        });
        if (target[element])
          target[element] = `Total: ${target[element].toFixed(2)}`
          console.log(target[element])
      });
    }
    return target;
  }
  onGridReady(params: any, value: any) {
    this.sourceColumnName = this.commonService.sourceColumnName;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    // if(this.commonService.glCountRecords === gl) {
    //   this.columnDefs = this.columnGlData;
    // }
    // if(this.commonService.glreconName) {
      this.columnDefs = this.columnData;
    // }
    // if(value === 'glcount') {
    //   setTimeout(() => { this.gridApi.setRowData(this.rowGlData) });
    //   console.log(this.rowGlData);
    // }
    // if(value === 'glview') {
      // setTimeout(() => { this.gridApi.setRowData(this.rowsData) });
      setTimeout(() => { this.gridApi.setRowData(this.rowsData); });
      // console.log("this.rowsData", this.rowsData);
    // }
    // let gridWidth: any = 50;
    // this.columnApi.sizeColumnsToFit(gridWidth);
    params.api.resetRowHeights();
    this.getAggridTableSetting();
    // setTimeout(()=>{
    //   let pinnedBottomData = this.generatePinnedBottomData();
    //   this.gridApi.setPinnedBottomRowData([pinnedBottomData]);
    // }, 1000)
    // let selectallnode: any = this.commonService.selectAllNode;
    // if(selectallnode === 'accountEntry') {
    //   setTimeout(() => {
    //     this.gridApi.forEachNode((node: any) => node.setSelected(true))
    //   }, 1000);
    // } else {
    //   return;
    // }
    console.log("this.columnData", this.columnData);
    console.log("this.rowData", this.rowsData);
  }
  ngOnInit() {
    this.chageDetect.detectChanges();
  }
  onSelectionChanged(event?: any) {
    // if(this.filteredRowdata.length > 0) {
    //   this.selectionChange.emit(this.filteredRowdata);
    //   this.selectedRow = this.filteredRowdata;
    //   console.log("all filtered row", this.selectedRow);
    // } else if(this.filteredRowdata.length === 0) {
      this.selectionChange.emit(this.gridApi.getSelectedRows());
      // console.log("selected Node", this.gridApi.getSelectedNodes());
      this.selectedRow = this.gridApi.getSelectedRows();
      // console.log("only selected row", this.selectedRow);
      // setTimeout(()=>{
      //   let pinnedBottomData = this.generatePinnedBottomData();
      //   this.gridApi.setPinnedBottomRowData([pinnedBottomData]);
      // }, 300)

    // }
  }
  onFilterChanged(event: any) {
    console.log("filter change", event);
    if(this.searchRec === "") { 
      this.filteredRowdata = [];
    } else {
      this.filteredRowCount = this.gridOptions.api.getDisplayedRowCount();
      this.filteredRowdata = [];
      this.gridApi.forEachNodeAfterFilter((node: any) => {
        if (node.data) { // Ensure that node.data is not undefined or null
          this.filteredRowdata.push(node.data);
        }
      });
      // this.filteredRecords = this.filteredRowdata;
      this.cs.filteredData.next(this.filteredRowdata);
      // this.filterChange.emit(this.filteredRowdata);
    }
  }
  applyFilter() {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.searchRec);
    }
  }
  refreshTable() {
    this.refreshCallback.emit();
  }
  clearSelectedRecords() {
    this.searchRec = null || "";
    this.applyFilter();
  }
  downloadSelectedRecords(type: string) {
    let fileName = this.currentReconProcess.reconName+'_'+this.sourceColumnName;
    let col: any = [];
    this.gridColumnApi.columnModel.columnDefs.map((e: any) => {
      if(e.headerName !== '#') {
        if(e.hide === false) {
          col.push(e.headerName);
        }
      }
    });
    if(this.selectedRow && this.selectedRow.length > 0) {
      if(type === 'excel') {
        this.gridApi.exportDataAsExcel({
          onlySelected: this.checked,
          fileName: fileName,
          columnKeys: col
        });
      } else if(type === 'csv') {
        this.gridApi.exportDataAsCsv({
          onlySelected: this.checked,
          fileName: fileName,
          columnKeys: col
        });
      }
    } else {
      this.toast.sToast('info', 'Please Select a recon');
    }
  }
  downloadAllRecordsAgGrid(type: string) {
    // let fileName = this.currentReconProcess.reconName+'_'+this.sourceColumnName
    if(type === 'excel') {
      if(this.reportBuilder === true) {
        let params: any = {}
        params = {
          data: this.selectedRow
        }
        this.gridApi.exportDataAsExcel(params);
        console.log(params);
      } else {
        setTimeout(() => {
          this.gridApi.exportDataAsExcel(this.getParams());
        }, 1000);
      }
    } else if(type === 'csv') {
      if(this.reportBuilder === true) {
        this.gridApi.exportDataAsCsv();
      } else {
      setTimeout(() => {
        this.gridApi.exportDataAsCsv( this.getParams());
      }, 1000);
      }
    }
  }
  getParams() {
    this.sourceColumnName = this.commonService.sourceColumnName;
    let fileName: any;
    if(this.commonService && this.commonService.glreconName) {
      fileName = this.commonService.glreconName;
    } else {
      fileName = this.currentReconProcess.reconName+'_'+this.sourceColumnName;
    }
    let col: any = [];
    this.gridColumnApi.columnModel.columnDefs.map((e: any) => {
      if(e.headerName !== '#') {
        if(e.hide === false) {
          col.push(e.headerName);
        }
      }
    });
    return {
      onlySelected: false,
      fileName: fileName,
      columnKeys: col
    };
  }
  onCellClicked (event: CellClickedEvent): void{
    // console.log(event);
    if(event.colDef.headerName === 'Ops Remarks' || event.colDef.headerName === 'Recon Remarks') {
      if(event.value === null || event.value === '' || event.value === undefined) {
        event.colDef.editable = true;
      } else {
        event.colDef.editable = false;
      }
    }
  }
  clickedAllRecords(event: any) {
    console.log(event);
    if(event === 'checked') {
      let c: any = 'checked';
      this.commonService.allrecordsClicked = c;
    } else if(event === 'unchecked') {
      let uc: any = 'uncheck';
      this.commonService.allrecordsClicked = uc;
    }
  }
  showAllRecs(value: any) {
    if(value === 'checked') {
      this.showAll = false;
      this.notshowAll = true;
    } else if(value === 'unchecked') {
      this.showAll = true;
      this.notshowAll = false;
    }
  }
  // onCellClickedForGlview(event: CellClickedEvent): any {
  //   console.log('event for the gl view', event);
  //   if(event.colDef.headerName === 'Count') {
  //     this.cs.glClickedEventData(event.data);
  //   } else {
  //     return false;
  //   }
  // }
  onCellValueChanged(event: any) {
    console.log(event);
    this.remarksData.push(event.data);
    console.log(this.remarksData)
  }
  saveRemarks() {
    let params = {};
    params = {
      reconId: this.currentReconProcess.reconId,
      records: JSON.stringify(this.remarksData),
      operations: this.sourceColumnName,
      stmtdate: ''
    }
    this.baseService.doRequest(`/api/recons/updateData`, 'post', params).subscribe((result: any) => {
      if(result.status === true) {
        this.toast.sToast('success', result.message);
        this.remarksData = [];
      } else {
        this.toast.sToast('error', result.message);
        this.remarksData = [];
      }
    });
  }

  /* For Report Builder */
  onColumnRowGroupChanged(event: any) {
    this.rowGroup = event && event.column && event.column.colId;
    console.log(event);
  }
  saveForReportBuilder() {
    this.allColumns = this.gridColumnApi.getAllColumns();
    let c: any;
    let p: any = [];
    let visible: boolean = false
    console.log(this.allColumns)
    this.allColumns.forEach((ele: any) => {
      if(ele.visible === true) {
        visible = false;
      } else {
        visible = true
      }
      c = Object.assign({}, {headerName: ele.colId, hide: visible});
      p.push(c)
    });
    this.gridOptions.api.forEachNodeAfterFilterAndSort((rowNode: any, index: number) => {
      console.log('node ' + rowNode.data.athlete + ' passes the filter and is in this order');
    });
    let params: any = {};
    params['table1'] = {
      'groupBy': {
        colId: this.rowGroup
      },
      'records': {
        rows: this.selectedRow
      },
      sheetWise: true
    }
    this.baseService.doRequest('', 'post', params).subscribe((result: any) => {
      console.log(result);
    })
  }
  saveGridTableSettings(): void {
    // this.allColumns = this.gridColumnApi.getAllColumns();
    this.allColumns = this.gridColumnApi.getColumnState();
    let c: any;
    let p: any = [];
    let visible: boolean = false
    this.allColumns.map((ele: any) => {
      c = Object.assign({}, {headerName: ele.colId, hide: ele.hide});
      p.push(c)
    });
    let params: any = {};
    if(this.gridTableSetting && this.gridTableSetting._id) {
      params = {
        "tableId": 'aggrid',
        "columnRepr": JSON.stringify(p),
        "refreshInterval": 0,
        //"userId": this.currentUser.email,
        "settings": "",
        "reconId": this.currentReconProcess === undefined || this.currentReconProcess.reconId === undefined ? this.glreconId : this.currentReconProcess.reconId,
        "function": this.commonService.funtionName,
        "source": this.sourceColumnName ? this.sourceColumnName : 'All',
        "_id": this.gridTableSetting._id,
        "c": this.gridTableSetting.c,
        "u": this.gridTableSetting.u,
      }
    } else {
      params = {
        "tableId": 'aggrid',
        "columnRepr": JSON.stringify(p),
        "refreshInterval": 0,
        //"userId": this.currentUser.email,
        "settings": "",
        "reconId": this.currentReconProcess === undefined || this.currentReconProcess.reconId === undefined ? this.glreconId : this.currentReconProcess.reconId,
        "function": this.commonService.funtionName,
        "source": this.sourceColumnName ? this.sourceColumnName : 'All',
      }
    }
    let method = this.gridTableSetting && this.gridTableSetting._id ? 'put' : 'post'; 
    const url = this.gridTableSetting && this.gridTableSetting._id ? `/api/aggridsettings/` : `/api/aggridsettings`;
    this.baseService.doRequest(url, method, params).subscribe((result: any) => {
      if(result) {
        if (method === 'post') {
          this.toast.sToast('success', 'Successfully saved table');
          this.getAggridTableSetting();
        } else {
          this.toast.sToast('success', 'Successfully updated');
          this.getAggridTableSetting();
        }
      } else {
        this.toast.sToast('error', result);
      }
    })
  }

  getAggridTableSetting() {
    console.log("this is form ag grid table");
    let params = {
      // 'query': { 'bool': { 'must': [{ 'match': { 'reconId.keyword': this.currentReconProcess === undefined || this.currentReconProcess.reconId === undefined ? this.glreconId : this.currentReconProcess.reconId, }}]}}
      'query': { 'reconId': this.currentReconProcess === undefined || this.currentReconProcess.reconId === undefined ? this.glreconId : this.currentReconProcess.reconId}
    }
    const q = JSON.stringify(params);
    const limit = 1000;
    this.baseService.doRequest(`/api/aggridsettings/`, 'get', null, {q, limit}).subscribe((result: any) => {
      console.log("get method from grid table", result)
      if(result.data && result.data.length > 1) {  
        this.gridTable = result.data;
        console.log('this from grid table');
        // let data = JSON.parse(this.gridTable);
        this.gridTableSetting = this.gridTable[this.gridTable.length - 1];
      } else if(result.data && result.data.length === 1) {
        this.gridTableSetting = this.gridTable[0];
      }
    })
  }

  changeSource(data: any) {
    this.changeSourceCallBack.emit(data);
  }
  changeUTR(data: any) {
    this.changeutrCallBack.emit(data)
  }
  allUTRNumbers: string[] = []; // All UTR numbers from your source
  filteredUTRNumbers: string[] = []; // Filtered UTR numbers based on search
  // onSearchChange(event: any) {
  //   let searchValue: any = event && event.target && event.target.value;
  //   this.getUTRNumbers = this.getUTRNumbers.filter(
  //     (utr: any) => utr.toLowerCase().includes(searchValue.toLowerCase())
  //   );
  // }
  searchValue: string = '';
  onSearchChange(event: any) {
    this.searchValue = event && event.target && event.target.value;
    this.filterUTRNumbers(this.searchValue);
  }
  filterUTRNumbers(searchValue: string) {
    this.getUTRNumbers = this.allUTRNumbers.filter(
      utr => utr.toLowerCase().includes(searchValue.toLowerCase())
    );
  }

  utrNumberList: any = [];
  reconAllData: any = [];
  storeSeparateData: any = [];
  Objectkeys = Object.keys;
  currentAllReconColumn: any = [];
  currentAllReconRow: any = [];
  rowCount: number =  0;
}
